export interface WebinarShortVm {
    id: number;
    title: string;
    airDate: Date;
    isLive: boolean;
    isCurrent: boolean;
} 

export class WebinarVm {
    id: number;
    title: string;
    airDate: Date;
    airTime: string;
    airTimeZoneId: number;
    airTimeZone: TimeZoneVm;
    duration: number;
    description: string;
    thumbnailImage: string;
    registrationLink: string;
    recordedLink: string;
    isLive: boolean;
    isActive: boolean;
    displayOrder: number;
    constructor(){
        this.id = 0;
    }
}

export interface TimeZoneVm {
    id: number;
    code: string;
}

